import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca6a4b46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_text mb-5" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "text-primary fs-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-double-right" }, null, -1))
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Collaborative activities", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = { class: "p-float-label prime_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "aim" }, [
  /*#__PURE__*/_createTextVNode("What is the aim of the partnership? "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_10 = { class: "p-float-label prime_input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "collaboration" }, [
  /*#__PURE__*/_createTextVNode("List priorities for collaboration "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_12 = { class: "p-float-label prime_input" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "modalities" }, [
  /*#__PURE__*/_createTextVNode("What are the terms and modalities for collaboration? "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Confidentiality", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "agreement" }, [
  /*#__PURE__*/_createTextVNode("What is the confidentiality agreement?"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Intellectual property", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = { class: "p-float-label prime_input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "publications" }, [
  /*#__PURE__*/_createTextVNode("Publications "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_21 = { class: "p-float-label prime_input" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "result" }, [
  /*#__PURE__*/_createTextVNode("Products resulting from collaboration "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Relationship of the parties", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "innovator_responsibility" }, [
  /*#__PURE__*/_createTextVNode("Responsibility of innovator"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "partner_responsibility" }, [
  /*#__PURE__*/_createTextVNode("Responsibility of partner"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "parties" }, [
  /*#__PURE__*/_createTextVNode("Use of the Parties’ names, disclosure, and publicity"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "communications" }, [
  /*#__PURE__*/_createTextVNode("Communications"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Terms and conditions", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "adjustment_terms" }, [
  /*#__PURE__*/_createTextVNode("Terms, termination, and amendment."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "settlement_terms" }, [
  /*#__PURE__*/_createTextVNode("Settlement of disputes, no waiver."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Innovator's Signature", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_35 = { class: "p-float-label prime_input" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "other" }, [
  /*#__PURE__*/_createTextVNode("Full Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_37 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Signature", -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "d-flex" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affirm" }, "I declare that all provided information is correct", -1))
const _hoisted_44 = { class: "d-flex justify-content-end" }
const _hoisted_45 = { class: "card border-0 card-body" }
const _hoisted_46 = { class: "card border-0 shadow-sm bg-light mb-3" }
const _hoisted_47 = { class: "d-flex justify-content-end w-100 mb-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " By signing this document with an electronic signature, I agree that such signature will be as valid as handwritten signatures and considered originals to the extent allowed by applicable law. ", -1))
const _hoisted_49 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_BaseFileLong = _resolveComponent("BaseFileLong")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_VueSignature = _resolveComponent("VueSignature")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ViewPartnerShipDeclaration = _resolveComponent("ViewPartnerShipDeclaration")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, [
        _createTextVNode(" Innovator Partner MOU "),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/partner/partnership-negotiation",
            class: "text-decoration-underline"
          }, {
            default: _withCtx(() => [
              _createTextVNode("View Declaration Form "),
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.partner.first_name) + " " + _toDisplayString(_ctx.partner.last_name), 1)
    ]),
    _createElementVNode("form", {
      ref: "Mou1",
      onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", null, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_InputText, {
            type: "text",
            id: "aim",
            name: "aim",
            modelValue: _ctx.form.aim,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.aim) = $event)),
            autocomplete: "aim"
          }, null, 8, ["modelValue"]),
          _hoisted_9
        ]),
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_InputText, {
            type: "text",
            id: "collaboration",
            name: "collaboration",
            modelValue: _ctx.form.collaboration,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.collaboration) = $event)),
            autocomplete: "collaboration"
          }, null, 8, ["modelValue"]),
          _hoisted_11
        ]),
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_InputText, {
            type: "text",
            id: "modalities",
            name: "modalities",
            modelValue: _ctx.form.modalities,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.modalities) = $event)),
            autocomplete: "modalities"
          }, null, 8, ["modelValue"]),
          _hoisted_13
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.agreement,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.agreement) = $event)),
          id: "agreement",
          name: "agreement",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_17,
        _hoisted_18,
        _createElementVNode("span", _hoisted_19, [
          _createVNode(_component_InputText, {
            type: "text",
            id: "publications",
            name: "publications",
            modelValue: _ctx.form.publications,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.publications) = $event)),
            autocomplete: "publications"
          }, null, 8, ["modelValue"]),
          _hoisted_20
        ]),
        _createElementVNode("span", _hoisted_21, [
          _createVNode(_component_InputText, {
            type: "text",
            id: "result",
            name: "result",
            modelValue: _ctx.form.result,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.result) = $event)),
            autocomplete: "result"
          }, null, 8, ["modelValue"]),
          _hoisted_22
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_23,
        _hoisted_24,
        _hoisted_25,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.innovator_responsibility,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.innovator_responsibility) = $event)),
          id: "innovator_responsibility",
          name: "innovator_responsibility",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_26,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.partner_responsibility,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.partner_responsibility) = $event)),
          id: "partner_responsibility",
          name: "partner_responsibility",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_27,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.parties,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.parties) = $event)),
          id: "parties",
          name: "parties",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_28,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.communications,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.communications) = $event)),
          id: "communications",
          name: "communications",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_29,
        _hoisted_30,
        _hoisted_31,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.adjustment_terms,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.adjustment_terms) = $event)),
          id: "adjustment_terms",
          name: "adjustment_terms",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_32,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.settlement_terms,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.settlement_terms) = $event)),
          id: "settlement_terms",
          name: "settlement_terms",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_BaseFileLong, {
          value: _ctx.fileProp,
          file: _ctx.file,
          "onUpdate:file": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.file) = $event))
        }, null, 8, ["value", "file"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_33,
        _hoisted_34,
        _createElementVNode("span", _hoisted_35, [
          _createVNode(_component_InputText, {
            type: "text",
            id: "fullname",
            name: "fullname",
            modelValue: _ctx.form.fullname,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.fullname) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_36
        ]),
        (this.form.signature !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("img", {
                src: this.form.signature,
                alt: "signature"
              }, null, 8, _hoisted_38),
              _hoisted_39
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "p-2 signature_activator",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showSignature = true))
        }, [
          (this.form.signature === '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_40, "Click here to insert signature"))
            : (_openBlock(), _createElementBlock("p", _hoisted_41, "Click to edit signature"))
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createVNode(_component_Checkbox, {
          id: "affirm",
          name: "affirm",
          value: "affirm",
          class: "mx-2",
          modelValue: _ctx.affirm,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.affirm) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_43
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createVNode(_component_BaseButton, {
          disabled: _ctx.loading,
          class: _normalizeClass({ submitting: _ctx.loading }),
          customStyle: _ctx.btnStyle,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Submit")
          ]),
          _: 1
        }, 8, ["disabled", "class", "customStyle"])
      ])
    ], 544),
    _createVNode(_component_Dialog, {
      visible: _ctx.showSignature,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showSignature) = $event)),
      style: { width: '80%' },
      modal: true,
      header: "Signature",
      dismissableMask: true,
      class: "hide_close"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_VueSignature, {
              width: "100%",
              height: "300",
              id: "signature",
              ref: "signaturePad",
              options: _ctx.options
            }, null, 8, ["options"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_Button, {
              label: "Undo",
              class: "p-button-text p-button-raised w-25",
              onClick: _withModifiers(_ctx.undo, ["prevent"]),
              "aria-label": "Undo"
            }, null, 8, ["onClick"])
          ]),
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_BaseButton, {
              disabled: _ctx.loading1,
              class: _normalizeClass({ submitting: _ctx.loading1 }),
              customStyle: _ctx.btnStyle,
              type: "button",
              onClick: _withModifiers(_ctx.handleSignature, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Accept and sign")
              ]),
              _: 1
            }, 8, ["disabled", "class", "customStyle", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: _ctx.declarationModalHeader,
      visible: _ctx.declarationModal,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.declarationModal) = $event)),
      style: { width: '30rem' },
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ViewPartnerShipDeclaration)
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}